import React from 'react';
import ReactDOM from 'react-dom';
import Chat from './Chat';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import "react-multi-date-picker/styles/layouts/prime.css"
import "react-multi-date-picker/styles/layouts/mobile.css"


let $hugoChat = document.getElementById('hugoChat');
if (!$hugoChat) {
  $hugoChat = document.createElement('div');
  $hugoChat.setAttribute('id', `hugoChat-${Date.now()}`);
  document.body.prepend($hugoChat);
}
ReactDOM.render(
  <React.StrictMode>
    <Chat />
  </React.StrictMode>,
  $hugoChat,
);
